import {mapMutations, mapGetters} from "vuex";

export default {
    name: "order-thanks",
    data() {
        return {
            isRegister: false
        }
    },
    methods: {
        ...mapMutations({
            changeShowThanksOrder: 'order/THANKS_ORDER',
            changeShowPopUpFastOrder: 'order/FAST_ORDER',
        }),
        closePopUp() {
            this.changeShowThanksOrder(false)
            this.changeShowPopUpFastOrder(false)
        }

    },
    computed: {
        ...mapGetters({
            showPopUpLogin: `auth/showPopUpLogin`
        }),
    },
    created() {
        setTimeout(this.closePopUp, 2000)
    }
}

